import React from "react";
import { Link } from "react-router-dom";
import {
  Activity, Radio, Disc3, Crosshair, Wind, Droplets, Truck, Cpu, ArrowUpRight,
} from "lucide-react";
import { SERVICES } from "@/data/services";

const ICONS = { Activity, Radio, Disc3, Crosshair, Wind, Droplets, Truck, Cpu };

export default function ServicesGrid() {
  return (
    <section id="hizmetler" data-testid="services-section" className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="divider-tick"></span>
              <span className="overline">HİZMETLER</span>
            </div>
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight max-w-3xl"
              style={{ fontFamily: "Outfit" }}
            >
              Kestirimci bakımda tek noktadan çözüm ortağınız.
            </h2>
          </div>
          <p className="text-slate-600 max-w-md text-base leading-relaxed">
            Saha ölçümünden online izlemeye, mekanik revizyondan otomasyona kadar
            kestirimci bakımda ihtiyaç duyduğunuz hizmetleri kendi ekibimiz ve
            gerektiğinde çözüm ortaklarımızla birlikte sunarız.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Activity;
            return (
              <Link
                key={s.slug}
                to={`/hizmetler/${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className="group bg-white p-7 lg:p-8 hover:bg-slate-50 transition-colors duration-300 relative card-lift"
                style={{ animation: `rise-in .5s ${i * 60}ms both` }}
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-12 h-12 grid place-items-center bg-slate-900 group-hover:bg-cyan-600 transition-colors rounded-sm">
                    <Icon className="w-6 h-6 text-cyan-400 group-hover:text-white" strokeWidth={1.5} />
                  </div>
                  <span className="font-mono-accent text-[10px] text-slate-400 tracking-[0.22em]">
                    {s.code}
                  </span>
                </div>
                <h3
                  className="text-lg font-bold text-slate-900 leading-snug mb-3"
                  style={{ fontFamily: "Outfit" }}
                >
                  {s.title}
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed mb-6 min-h-[60px]">
                  {s.short}
                </p>
                <div className="flex items-center gap-2 text-sm font-semibold text-cyan-700 group-hover:text-cyan-600">
                  Detaylar
                  <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
